module.exports = __webpack_public_path__ + "02f35f44d4179aba2658add5ff4b77f9.svg";